module.exports = __webpack_public_path__ + "static/dhuhr-91e2050af6f2929207b53b8e29a7e5b7.jpeg";